// extracted by mini-css-extract-plugin
module.exports = {"medalContainer":"Medals-module--medalContainer--2ZO4f","medal2":"Medals-module--medal2--3j-oj","medal3":"Medals-module--medal3--vI5fc","medal4":"Medals-module--medal4--3trAn"};